<template>
  <form class="d-corporate-program-form__form" @submit.prevent="submit">
    <div class="d-corporate-program-form__row">
      <div class="d-input" :class="{ _error: v$.form.name.$errors.length }">
        <input type="text" name="name" placeholder="Ваше имя" class="d-input__field" v-model="v$.form.name.$model" :disabled="loading" @blur="v$.form.name.$touch">
        <div class="d-input__error" v-for="(error, index) of v$.form.name.$errors" :key="index">{{ error.$message }}</div>
      </div>
    </div>
    <div class="d-corporate-program-form__row">
      <div class="d-input" :class="{ _error: v$.form.phone.$errors.length }">
        <div class="d-input__error" v-for="(error, index) of v$.form.phone.$errors" :key="index">{{ error.$message }}</div>
        <d-phone-input @change-phone="setPhone" @change-mask="updatePhoneParams" :reset="reset" @blur="blurInpPhone"/>
      </div>
    </div>
    <div class="d-corporate-program-form__row">
      <div class="d-input" :class="{ _error: v$.form.email.$errors.length }">
        <input type="text" name="email" placeholder="Ваш e-mail*" class="d-input__field" v-model="v$.form.email.$model" :disabled="loading" @blur="v$.form.email.$touch">
        <div class="d-input__error" v-for="(error, index) of v$.form.email.$errors" :key="index">{{ error.$message }}</div>
      </div>
    </div>
    <div class="d-corporate-program-form__row">
      <div class="d-input" :class="{ _error: v$.form.company_name.$errors.length }">
        <input type="text" name="company_name" placeholder="Наименование компании*" class="d-input__field" v-model="v$.form.company_name.$model" :disabled="loading" @blur="v$.form.company_name.$touch">
        <div class="d-input__error" v-for="(error, index) of v$.form.company_name.$errors" :key="index">{{ error.$message }}</div>
      </div>
    </div>
    <div class="d-corporate-program-form__row _agree">
      Нажимая кнопку, вы соглашаетесь&nbsp;с <a :href="dataAgreeLink" target="_blank">условиями обработки персональных данных</a>
    </div>
    <button class="d-corporate-program-form__button d-button _blue" @click.prevent="submit">
      <span>Получить консультацию</span>
    </button>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {email, helpers, required, sameAs} from '@vuelidate/validators';
import phoneHelper from '@utils/phoneHelper';
import Inputmask from 'inputmask';
import DPhoneInput from '@components/molecules/DPhoneInput.vue';

export default {
  name: 'DCallMeFormCorporate',
  components: {
    DPhoneInput,
  },
  props: {
    dataActionUrl: {
      type: String,
      required: true,
      default: '',
    },
    dataAgreeLink: {
      type: String,
      default: '#',
    },
  },
  setup() {
    return {v$: useVuelidate()};
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        company_name: '',
        agree: true,
      },
      errored: false,
      errorText: 'Ошибка при инициализации reCAPTCHA, попробуйте перезагрузить страницу',
      loading: false,
      phoneParams: {
        mask: '',
        code: '',
      },
      reset: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      Inputmask('+9 (999) 999-99-99', {jitMasking: true, placeholder: ''}).mask($(this.$refs.tel));
    });
    this.v$.form.agree.$touch();
  },
  methods: {
    submit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        this.sendData({...this.form, formType: 'corporate'});
      }
    },
    async sendData(formdata) {
      formdata.URL = formdata.url = window.location.href;
      this.loading = true;
      try {
        //await this.$recaptchaLoaded(); // TODO вернуть
        //formdata.token = await this.$recaptcha(this.dataType);
        const response = await this.axios.post(this.dataActionUrl, formdata);
        if (response.data.error) {
          this.errored = true;
          this.errorText = response.data.error;
        }
        else if (response.data.success) {
          this.resetForm();
          window.layoutAapp.$vfm.show({component: 'DPopupSuccess', bind: Object.assign({}, response.data, {content: response.data.success})});
        }
        else {
          console.error(response.data);
          this.errored = true;
        }
      } catch (error) {
        console.error(error);
        this.errored = true;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.v$.form.$reset();
      this.form.name = '';
      this.form.phone = '+7 ';
      this.form.company_name = '';
      this.form.email = '';
      this.form.agree = true;
      const self = this;
      this.$nextTick(() => {
        self.v$.$reset();
      });
      this.reset = true;
      setTimeout(() => {this.reset = false;}, 1000);
    },
    updatePhoneParams(data) {
      this.phoneParams.mask = data.mask;
      this.phoneParams.code = data.code;
    },
    setPhone(phone) {
      this.form.phone = phone;
      console.log('setPhone phone = ', phone);
    },
    blurInpPhone() {
      this.v$.form.phone.$touch();
      console.log('touch phone');
    },
  },
  validations() {
    return {
      form: {
        name: {},
        phone: {
          required: helpers.withMessage('Заполните это поле', required),
          phoneHelper: helpers.withMessage('Введите номер полностью', phoneHelper(this.phoneParams)),
        },
        email: {
          required: helpers.withMessage('Заполните это поле', required),
          email: helpers.withMessage('Некорректный email', email),
        },
        company_name: {
          required: helpers.withMessage('Заполните это поле', required),
        },
        agree: {
          required,
          sameAs: sameAs(true),
        },
      },
    };
  },
};
</script>

